// extracted by mini-css-extract-plugin
module.exports = {"sideMenu":"SideMenu_sideMenu__-94lB"};